module.exports = __webpack_public_path__ + "img/pancakeswap.9b0270c4.png";